var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v("Plinko (" + _vm._s(this.rules.name) + ")"),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "mb-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          label: "UID:",
                          "hide-details": "",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.model.uid,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "uid",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.uid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Name" },
                        model: {
                          value: _vm.model.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-expansion-panels",
                [
                  _c(
                    "r-panel",
                    { attrs: { title: "Settings" } },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4", md: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Icon Badge Expires",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.model.iconBadgeExpires,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "iconBadgeExpires",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "model.iconBadgeExpires",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4", md: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Icon Tooltip Reset",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.model.iconTooltipReset,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "iconTooltipReset",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "model.iconTooltipReset",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("r-guard-panel", {
                    attrs: { model: _vm.model.guard, title: "Guard Config" },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "guard", $event)
                      },
                    },
                  }),
                  _c("r-guard-money-panel", {
                    attrs: {
                      model: _vm.model.guardMoney,
                      title: "Guard Money",
                    },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "guardMoney", $event)
                      },
                    },
                  }),
                  _c("r-reward-panel", {
                    attrs: {
                      model: _vm.model.rewardOnMerge,
                      title: "Reward on merge",
                    },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "rewardOnMerge", $event)
                      },
                    },
                  }),
                  _c("r-smart-offer-reset-currency", {
                    attrs: {
                      items: _vm.model.resetCurrency,
                      title: "Reset Currency",
                    },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "resetCurrency", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    [
                      _c("r-plinko-game-config-panel", {
                        attrs: {
                          model: _vm.model.gameConfig,
                          title: "Game Config",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "gameConfig", $event)
                          },
                        },
                      }),
                      _c("r-plinko-exchange-config-panel", {
                        attrs: {
                          model: _vm.model.exchangeConfig,
                          title: "Exchange Config",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "exchangeConfig", $event)
                          },
                        },
                      }),
                      _c("r-reward-track-panel", {
                        attrs: {
                          model: _vm.model.defaultTrack,
                          title: "Reward Track",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "defaultTrack", $event)
                          },
                        },
                      }),
                      _c("r-reward-track-panel", {
                        attrs: {
                          model: _vm.model.premiumTrack,
                          payable: true,
                          reminder: true,
                          title: "Premium Track",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "premiumTrack", $event)
                          },
                        },
                      }),
                      _c("r-reward-track-panel", {
                        attrs: {
                          model: _vm.model.exchangeTrack,
                          title: "Exchange Track",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "exchangeTrack", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }